import { observable, action, computed } from "mobx"
import request from "app/vendor/request"
import config from "app/config"

export default class {
  @observable apps = []
  @observable selectedRecycle = "data"
  @observable tableData = []
  @observable totalCount = 0
  @observable currentPageIndex = 1
  @observable queryMap = {
    belong: null,
    app: null,
    start: null,
    end: null,
    offset: 0,
    limit: 10,
    keywords: null,
    deleted: true,
  }

  @action getApps = () => {
    request.get(`${config.backend}/pgd/apps?filter=used`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.apps = res
      })
  }

  @action getTableData = () => {
    if (this.selectedRecycle === "data") {
      return request.get(`${config.backend}/pgd/family?${this.queryString}`)
        .checkToken()
        .dataListDispose()
    } else {
      return request.get(`${config.backend}/pgd/groups/reports?${this.queryString}`)
        .checkToken()
        .dataListDispose()
    }
  }

  @computed get queryString() {
    let queryCount = 0
    let queryString = ""
    for (var key in this.queryMap) {
      if (queryCount === 0 && queryString[key] !== undefined) {
        queryString = `${key}=${this.queryMap[key]}`
      } else {
        if (this.queryMap[key] !== null) {
          queryString += `&${key}=${this.queryMap[key]}`
        } else {
          queryString += ""
        }
      }
    }
    return queryString
  }

  @action updateTableData = (data) => {
    this.totalCount = data.totalCount
    this.tableData = data.dataList
  }

  @action updateDataListData = (data) => {
    this.totalCount = data.totalCount
    this.tableData = data.dataList
  }

  @action initOffset = () => {
    this.queryMap.offset = 0
  }

  @action updateQueryMap = (data) => {
    this.queryMap = { ...this.queryMap, ...data }
  }

  @action initPageIndex = () => {
    this.currentPageIndex = 1
  }

  @action clearState = () => {
    this.tableData = []
    this.totalCount = 0
    this.currentPageIndex = 1
    this.queryMap = {
      belong: null,
      app: null,
      start: null,
      end: null,
      offset: 0,
      limit: 10,
      keywords: null,
      deleted: true
    }
  }

  @action setSelectedRecycle = (type) => {
    this.selectedRecycle = type
  }

  @action recoveryData = (groupId, reportId) => {
    return request.put(`${config.backend}/pgd/groups/${groupId}/reports/${reportId}/recovery`)
      .checkToken()
      .commonDispose()
  }

  @action getTaskDatas = (familyId, taskId) => {
    return request.get(`${config.backend}/pgd/family/${familyId}/tasks/${taskId}/datas`)
      .checkToken()
      .commonDispose()
  }

  @action setTaskDatas = (index, id, data) => {
    const rowIndexInCard = this.tableData[index].reportList.findIndex(item => item.id === id)
    this.tableData[index].reportList[rowIndexInCard].datas = data
  }

}



// WEBPACK FOOTER //
// ./src/app/stores/pgd/recycle.js